var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"cursor":"pointer"},attrs:{"srcset":this.imgSrcset,"sizes":this.imgSizes,"src":this.imgSrc},on:{"click":_vm.click}})}
var staticRenderFns = []

export { render, staticRenderFns }